import DtoReferencial from './DtoReferencial'

export default class DtoState extends DtoReferencial {
    constructor(obj) {
        super(obj)
    }
}
